import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { getAuthAPIUrl } from "../api/apiUtils";
import { getAPIUrl } from "../api/apiUtils";
import { apiFetch } from "../api/apiClient";
import './Authorization.scss';

const AUTH_API_BASE_URL = getAuthAPIUrl();

function Login({ setUser }) {
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const navigate = useNavigate();

  // Проверка: если пользователь уже авторизован, перенаправляем на главную
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      navigate("/");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Начало замера времени входа
    console.time('loginProcess');

    // Логирование попытки входа
    console.log('Попытка входа', {
      timestamp: new Date().toISOString(),
      username: credentials.username,
      action: 'login_initiated'
    });

    try {
      const response = await axios.post(`${AUTH_API_BASE_URL}/profile/login`, {
        username: credentials.username,
        password: credentials.password,
      });

      const { token } = response.data;
      localStorage.setItem("token", token);

      const decodedToken = JSON.parse(atob(token.split('.')[1]));
      // --- Получаем id пользователя по username ---
      const usersRes = await apiFetch(`${getAPIUrl()}/users/users`);
      const users = await usersRes.json();
      const foundUser = users.find(u => u.username === credentials.username);
      if (!foundUser) {
        alert('Пользователь не найден!');
        return;
      }
      const userData = { 
        role: decodedToken.role, 
        username: credentials.username,
        id: foundUser.id, 
        loginTime: new Date().toISOString()
      };
      
      // Логирование успешного входа
      console.log('Вход успешен', {
        timestamp: new Date().toISOString(),
        username: credentials.username,
        role: decodedToken.role,
        action: 'login_success'
      });

      // Завершение замера времени
      console.timeEnd('loginProcess');

      localStorage.setItem("user", JSON.stringify(userData));
      setUser(userData);

      // --- Загрузка запрещённых страниц ---
      try {
        const res = await apiFetch(`${getAPIUrl()}/users/user_access/${userData.id}`, { cache: 'no-store' });
        const data = await res.json();
        const deniedPages = data.filter(a => a.can_view).map(a => a.page);
        localStorage.setItem('deniedPages', JSON.stringify(deniedPages));
      } catch (e) {
        localStorage.setItem('deniedPages', JSON.stringify([]));
      }

      navigate("/");
    } catch (err) {
      // Логирование неуспешного входа
      console.error('Ошибка входа', {
        timestamp: new Date().toISOString(),
        username: credentials.username,
        error: err.response?.data?.error || err.message,
        action: 'login_failed'
      });

      // Завершение замера времени даже при ошибке
      console.timeEnd('loginProcess');

      alert(err.response?.data?.error || "Ошибка при входе");
    }
  };

  return (
    <div className="authorization">
      <div className="authorization-container-main mt-5">
        <div className="authorization-brand-text">Socio.Parser</div>
        <div className="authorization-container">
          <h2 className="authorization-title">Вход</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="text"
                className="authorization-custom-input"
                placeholder="Имя пользователя"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              />
            </div>
            <div className="mb-3">
              <input
                type="password"
                className="authorization-custom-input"
                placeholder="Пароль"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                autoComplete="current-password"
              />
            </div>
            <button type="submit" className="btn authorization-custom-button">
              Войти
            </button>
          </form>
          <div className="authorization-link">
            Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
